import { getCalcStylePx } from "./CssUtils";

export function scrollToTop() {
  document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
}

export function getOffsetTop(element) {
  return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
}

/**
 * Scrolls element into view considering top navigation (--menu-height) and eventual messages (--padding-top)
 * @param element
 * @param options (optional)
 */
export function scrollToElement(element, { container } = {}) {
  const verticalOffset = getCalcStylePx(
    "calc(var(--padding-top) + var(--menu-height) + 1rem)"
  );
  const offsetTop = getOffsetTop(element);
  (container ?? document.documentElement).scrollTo({
    top: offsetTop - verticalOffset,
    behavior: "smooth"
  });
}

export function scrollIntoViewHorizontally(container, child, mode = "center") {
  const scrollSpan = container.scrollWidth - container.offsetWidth;
  switch (mode) {
    case "nearest":
      // is child behind (left)
      if (container.scrollLeft > child.offsetLeft) {
        container.scrollTo({
          left: child.offsetLeft,
          behavior: "smooth"
        });
      }

      // is child ahead (right)
      if (
        container.scrollLeft + container.offsetWidth <
        child.offsetLeft + child.offsetWidth
      ) {
        container.scrollTo({
          left: child.offsetLeft + child.offsetWidth - container.offsetWidth,
          behavior: "smooth"
        });
      }
      break;

    case "center":
    default:
      if (scrollSpan > 0) {
        container.scrollTo({
          left: (scrollSpan * child.offsetLeft) / container.scrollWidth,
          behavior: "smooth"
        });
      }
  }
}
